/**
 * Auto-generated from @intelishs-group/schema-core v4.25.13
 * Source: recursoshumanosTypes — Recursos Humanos — FestivosController (dias festivos y calculo de dias habiles)
 * Generated: 2026-09-17
 * Do not edit manually. Run: npm run generate:services
 */
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiBaseService } from './api-base.service';
import type {
  CreateDiaFestivoRequest,
  DiaFestivoResponseListResponseDto,
  DiaFestivoResponseResponseDto,
  Int32ResponseDto,
  ProblemDetails,
  UpdateDiaFestivoRequest,
} from '@schemas/rh-festivos';

@Injectable({ providedIn: 'root' })
export class RhFestivosService extends ApiBaseService {
  private baseUrl = `${environment.BaseUrl}/Festivos`;

  /** Obtener festivos de un año específico. */
  async festivosByAnio(anio: number) {
    return this.get<DiaFestivoResponseListResponseDto>(`${this.baseUrl}/${anio}`);
  }

  /** Obtener festivos de múltiples años en una sola llamada. Ejemplo: GET /api/festivos?anios=2025&anios=2026 */
  async getFestivos(anios: number[]) {
    return this.get<DiaFestivoResponseListResponseDto>(`${this.baseUrl}`, {
      anios: anios,
    });
  }

  /** Crear un nuevo festivo. */
  async createFestivos(body: CreateDiaFestivoRequest) {
    return this.post<DiaFestivoResponseResponseDto>(`${this.baseUrl}`, body);
  }

  /** Calcular días hábiles entre dos fechas (excluyendo fines de semana y festivos). */
  async diasHabiles(inicio: string, fin: string) {
    return this.get<Int32ResponseDto>(`${this.baseUrl}/dias-habiles`, {
      inicio: inicio,
      fin: fin,
    });
  }

  /** Actualizar un festivo existente. */
  async updateFestivosById(id: number, body: UpdateDiaFestivoRequest) {
    return this.put<DiaFestivoResponseResponseDto>(`${this.baseUrl}/${id}`, body);
  }

  /** Desactivar un festivo (soft delete). */
  async deleteFestivosById(id: number) {
    return lastValueFrom(this.http.delete<ProblemDetails>(`${this.baseUrl}/${id}`));
  }
}
